import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, connect } from 'react-redux';

import Intro from './Intro';
import VariableCost from './VariableCost';
import FixedCost from './FixedCost';
import Summary from './Summary';
import Section from '../../components/Section';
import * as AppRoute from '../../utils/appRoutes';
import { prepareComponents } from '../../utils/helpers';
import { select } from '../../rematcher/store';

const components = [Intro, FixedCost, VariableCost, Summary];

function Cost({
  locales,
  locales: {
    cost: { name, menu, sectionName },
  },
  progress,
}) {
  const {
    cost: { fetchCosts },
    product: { fetchProducts },
    bmc: { fetchCurrentBmc },
  } = useDispatch();

  const { bmcId } = useParams();
  const preparedComponents = prepareComponents(
    components,
    bmcId,
    menu,
    AppRoute.cost,
  );

  const getData = useCallback(() => {
    fetchCurrentBmc(bmcId);
    fetchCosts(bmcId);
    fetchProducts(bmcId);
  }, [bmcId]);

  useEffect(() => {
    getData();
  }, []);
  return (
    <Section
      components={preparedComponents}
      sectionName={sectionName}
      sectionLocaleName={name}
      menuItems={menu}
      progress={progress}
      locales={locales}
      finalDestination={AppRoute.bmc(bmcId)}
      onComponentChange={getData}
    />
  );
}

const mapState = select((models) => ({
  progress: models.progress.costProgress,
}));

export default connect(mapState, null)(Cost);
